document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-okz-drawer]');
  const openButton = document.querySelector('[data-okz-menu-open]');
  const closeButton = document.querySelector('[data-okz-menu-close]');

  if (!drawer || !openButton || !closeButton) return;

  openButton.addEventListener('click', () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  });

  closeButton.addEventListener('click', () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  });
});

(() => {
  const header = document.querySelector('[data-okz-header]');
  if (!header) return;

  const drawer = header.querySelector('[data-okz-drawer]');
  const openButton = header.querySelector('[data-okz-menu-open]');
  const closeButtons = header.querySelectorAll('[data-okz-menu-close]');
  const overlay = header.querySelector('.okz-drawer-overlay');

  if (!drawer || !openButton) return;

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('okz-drawer-open');
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.classList.remove('okz-drawer-open');
  }

  openButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    openDrawer();
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawer();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawer();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });
})();